let schedule = {};

export const getSchedule = async () => {
  const fetschSchedule = async () => {
    const response = await fetch(process.env.REACT_APP_DB_URL + "/schedule");
    const data = await response.json();
    console.log('getSchedule: ', data);
    return data;
  };

  schedule = await fetschSchedule();

  return schedule;
};

export const putSchedule = async (user, mydays, myschedule) => {
  const fetschSchedule = async () => {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user, mydays, myschedule }),
    };
    const response = await fetch(
      process.env.REACT_APP_DB_URL + "/schedule",
      requestOptions
    );
    const data = await response.json();
    console.log(data);
    return data;
  };

  schedule = await fetschSchedule();

  return schedule;
};
